import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import RefinePVLSearchForm from './refinePVLSearchForm';
import RefineCVLSearchForm from './refineCVLSearchForm';
import Axios from 'axios';
import ErrorBlock from './errorBlock';
import SelectInput from './selectInput';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import { parse } from 'qs';
import { withRouter } from 'react-router-dom';
import store from '../store';
import { storeReg, storeEnvUrl, storeEnvToken } from '../actions';

class SearchTabs extends Component {
  state = {
    selectedTabId: null,
    error: false,
    errorSource: null,
    updated: false,
    search: '',
    vrm: '',
    PVLData: null,
    CVLData: null,
    flagImageError: false,
    showSearchLoader: false,
  };

  ref = React.createRef();

  componentDidMount() {
    const { t, location } = this.props;
    const query = parse(location.search, { ignoreQueryPrefix: true });
    const tokenKey = query.distributor !== undefined ? '_DISTRIBUTOR_TOKEN' : '_TOKEN';
    const url =
      process.env.REACT_APP_ENV === 'production' ? t('config.PROD_URL') :
        process.env.REACT_APP_ENV === 'staging' ? t('config.STAGING_URL') :
          process.env.REACT_APP_ENV === 'dev' ? t('config.DEV_URL') :
            t('config.STAGING_URL');

    const token =
      process.env.REACT_APP_ENV === 'production'
        ? t(`config.PROD${tokenKey}`)
        : process.env.REACT_APP_ENV === 'staging'
          ? t(`config.STAGING${tokenKey}`)
          : process.env.REACT_APP_ENV === 'dev'
            ? t(`config.DEV${tokenKey}`)
            : t(`config.STAGING${tokenKey}`);
    const initialActiveTab = t('config.show_vrm') ? 'registration' : 'search';

    store.dispatch(storeEnvUrl(url));
    store.dispatch(storeEnvToken(token));

    this.getGroups();

    if (this.props.searchOnly) {
      this.setState({ type: '' });
      this.getTypeOptions();
    }

    this.setActiveTab(initialActiveTab);
  }

  componentDidUpdate(prevProps) {
    const { searchOnly, selectedFamily, equipmentState } = this.props;

    if (prevProps.selectedFamily !== selectedFamily) {
      this.setState({
        updated: false,
        error: false,
        errorSource: null,
        vrmSearchManufacturer: null,
        vrmSearchResults: null,
        search: '',
        vrm: '',
        type: '',
        typeOptions: null,
      });

      if (searchOnly) {
        this.getTypeOptions();
      }
    }

    // Reset form when coming back from results
    if (prevProps.equipmentState && !equipmentState) {
      this.setState({
        updated: false,
        error: false,
        errorSource: null,
        PVLData: null,
        CVLData: null,
        vrmSearchManufacturer: null,
        vrmSearchResults: null,
        search: '',
        vrm: '',
        type: '',
      });

      if (this.props.onSearchComplete) {
        this.props.onSearchComplete(false);
      }
    }
  }

  setLob = (i18n) => ['is', 'fr-be', 'nl-be'].indexOf(i18n.language) > -1;

  isActive = (id) => {
    return this.state.selectedTabId === id;
  };

  setActiveTab = (selectedTabId) => {
    this.setState({
      selectedTabId,
      updated: false,
      error: false,
      errorSource: null,
      vrmSearchManufacturer: null,
      vrmSearchResults: null,
    });

    if (this.ref && this.state.selectedTabId) {
      Scroll.animateScroll.scrollTo(this.ref.offsetTop, { duration: 250 });
    }
  };

  equipment = (data) => {
    this.props.equipment({ equipment: data });
  };

  handleTypeChange = (value) => {
    this.setState({
      type: value,
      updated: false,
      error: false,
      errorSource: null,
    });
  };

  // Get family groups
  // needs to be done first before any proceeding api calls (except for VRM search)
  getGroups = () => {
    const { i18n, t } = this.props;
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = { culture: t('config.CULTURE') };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    Axios.get(url + '/api/browse', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        this.setState({
          groups: response.data.family_groups,
        });
      })
      .catch((error) => {
        this.setState({ error: t('search_tabs.error') });
        console.warn(error);
      });
  };

  // For CVL dropdown
  getTypeOptions = () => {
    const { i18n, t, selectedFamily } = this.props;
    const url = store.getState().content.url;
    const token = store.getState().content.token;

    const params = {
      culture: t('config.CULTURE'),
      group: selectedFamily,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    const capturedFamily = selectedFamily;

    Axios.get(url + '/api/oem/family', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        if (this.props.selectedFamily !== capturedFamily) return;

        const arr = [];

        response.data.families.forEach((element) => {
          // exclude vans
          if (selectedFamily === 'commercial' && element.key.includes('vans')) return;

          let options = {
            value: element.val,
            label: element.val,
            key: element.key,
          };

          arr.push(options);
        });

        this.setState({ typeOptions: arr });

        if (arr.length === 1) {
          this.handleTypeChange(arr[0]);
        }
      })
      .catch((error) => {
        if (this.props.selectedFamily !== capturedFamily) return;

        this.setState({ error: t('search_tabs.error') });
        console.warn(error);
      });
  };

  handleVRMSubmit = (e) => {
    e.preventDefault();
    const { i18n, t } = this.props;
    const { vrm } = this.state;
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const searchTerms = vrm.toUpperCase();
    const params = {
      culture: t('config.CULTURE'),
      vrm: searchTerms,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    this.setState({
      updated: false,
      error: false,
      errorSource: null,
      vrmSearchManufacturer: null,
      vrmSearchResults: null,
      showVRMLoader: true,
    });

    Axios.get(url + t('config.VRM_END_POINT'), {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        if (response.data.model.length === 1) {
          store.dispatch(storeReg(searchTerms));

          this.equipment({
            value: response.data.model[0].display_name_long,
            label: response.data.model[0].display_name_long,
            key: response.data.model[0].equipment,
          });
        } else if (response.data.model.length > 1) {
          const results = [];

          store.dispatch(storeReg(searchTerms));

          response.data.model.forEach((model) => {
            results.push({
              value: model.display_name_long,
              label: model.display_name_long,
              key: model.equipment,
            });
          });

          this.setState({
            vrmSearchManufacturer: response.data.model[0].manufacturer,
            vrmSearchResults: results,
          });
        } else {
          this.setState({ error: t('search_tabs.no_results'), errorSource: 'vrm' });
        }

        this.setState({ showVRMLoader: false });
      })
      .catch((error) => {
        this.setState({
          showVRMLoader: false,
          error: t('search_tabs.no_results'),
          errorSource: 'vrm',
        });

        console.warn(error);
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { i18n, t, searchOnly, selectedFamily } = this.props;
    const { groups, type } = this.state;
    if (searchOnly && !type) return;



    const familyGroup = groups.find((group) => group.key === selectedFamily) ? groups.find((group) => group.key === selectedFamily).val : '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const searchTerms = this.state.search;

    const capturedFamily = selectedFamily;
    const capturedType = type;
    const capturedSearch = searchTerms;

    this.setState({ familyGroup, error: false, errorSource: null, updated: false, showSearchLoader: true });
    store.dispatch(storeReg(''));

    //family is now
    //PVL - Cars or Vans - vtype 1
    //CVL - Sub selection from type dropdown - vtype 2
    const params = {
      culture: t('config.CULTURE'),
      vtype: searchOnly ? '2' : '1',
      facets: {
        familygroup: familyGroup,
      },
      text: searchTerms,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    if (searchOnly) {
      params.facets.family = type.value;
    }

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        if (
          this.props.selectedFamily !== capturedFamily ||
          (searchOnly && this.state.type !== capturedType) ||
          this.state.search !== capturedSearch
        ) {
          this.setState({ showSearchLoader: false });
          return;
        }

        if (response.data.model.length > 0) {
          //show the error message if the search term is empty
          if (searchTerms === '') {
            this.setState({ error: t('search_tabs.no_results'), errorSource: 'search', showSearchLoader: false });
          }
          //if we are on CVL we need to filter the results first.
          if (searchOnly) {
            this.setCVLData(response.data, searchTerms);
          } else {
            this.setPVLData(response.data, searchTerms);
          }
        } else {
          this.setState({ error: t('search_tabs.no_results'), errorSource: 'search', showSearchLoader: false });
        }
        this.setState({ showSearchLoader: false });
      })
      .catch((error) => {
        if (
          this.props.selectedFamily !== capturedFamily ||
          (searchOnly && this.state.type !== capturedType) ||
          this.state.search !== capturedSearch
        ) {
          this.setState({ showSearchLoader: false });
          return;
        }

        this.setState({ error: t('search_tabs.error'), errorSource: 'search', showSearchLoader: false });
        console.warn(error);
      });
  };

  /**
   * Get CVL manufacturers if nothing comes back from the initial search
   */
  getCVLData = () => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups, type } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = {
      culture: t('config.CULTURE'),
      vtype: '2',
      text: `${familyGroup} ${type.value}`,
      facets: {
        familygroup: familyGroup,
        family: type.value,
      },
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    return Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  setCVLData = (results, searchTerms) => {
    const { groups, type } = this.state;

    this.setState({
      CVLData: {
        results,
        searchTerms,
        groups,
        type,
      },
      updated: true,
    });

    if (this.props.onSearchComplete) {
      this.props.onSearchComplete(true);
    }
  };

  /**
   * Get PVL manufacturers if nothing comes back from the initial search
   */
  getPVLData = () => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = {
      culture: t('config.CULTURE'),
      vtype: '1',
      text: familyGroup,
      facets: { familygroup: familyGroup },
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    return Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  setPVLData = (results, searchTerms) => {
    const { groups } = this.state;

    this.setState({
      PVLData: {
        results,
        searchTerms,
        groups,
      },
      updated: true,
    });

    if (this.props.onSearchComplete) {
      this.props.onSearchComplete(true);
    }
  };

  handleVRMInputChange = (e) => {
    this.setState({ vrm: e.target.value.toUpperCase() });
  };

  handleSearchInputChange = (e) => {
    this.setState({ search: e.target.value });
  };

  handleFlagImageError = () => {
    this.setState({ flagImageError: true });
  };

  clearVRMInput = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ vrm: '' });
  };

  clearSearchInput = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ search: '' });
  };

  render() {
    const { i18n, t, searchOnly, selectedFamily } = this.props;
    const {
      PVLData,
      CVLData,
      typeOptions,
      type,
      updated,
      error,
      groups,
      vrmSearchManufacturer,
      vrmSearchResults,
      showVRMLoader,
      showSearchLoader,
    } = this.state;
    const { search } = this.state;

    const errorBlock = <ErrorBlock error={error} />;

    const loader = (
      <div className="loading-block">
        <div className="loader" />
      </div>
    );



    const flagImage = this.state.flagImageError ? 'flags/union.png' : t('config.vrm_flag_image') || 'flags/union.png';

    const registrationContent = (
      <div className={`registration-input-wrapper ${this.state.errorSource === 'vrm' ? 'has-error' : ''}`}>
        <form onSubmit={this.handleVRMSubmit}>
          <div className="country-logo" style={{ backgroundImage: `url(images/${flagImage})` }}>
            <img
              src={`images/${t('config.vrm_flag_image')}`}
              alt="country flag"
              style={{ display: 'none' }}
              onError={this.handleFlagImageError}
            />
          </div>
          <input
            type="text"
            className="reg-input"
            value={this.state.vrm}
            onChange={this.handleVRMInputChange}
            placeholder={t('search_tabs.registration_number')}
            disabled={showVRMLoader || showSearchLoader}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && this.state.vrm !== '') {
                ReactGA.event({
                  category: i18n.language,
                  action: selectedFamily,
                  label: 'VRM Submit',
                });
              }
            }}
          />
          {this.state.vrm && (
            <button type="button" className="clear-button" onClick={this.clearVRMInput} onTouchEnd={this.clearVRMInput} aria-label="Clear">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="rgba(32, 32, 32, 1)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
          <button type="submit" aria-label="Submit">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90 12 12)" />
            </svg>
          </button>
        </form>
      </div>
    );

    const searchContent = (
      <div className={`search-input-wrapper ${this.state.errorSource === 'search' ? 'has-error' : ''} ${searchOnly && !type ? 'disabled' : ''}`}>
        <form onSubmit={this.handleSubmit}>
          <svg className="search-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 28L21.65 21.65M25 14C25 20.0751 20.0751 25 14 25C7.92487 25 3 20.0751 3 14C3 7.92487 7.92487 3 14 3C20.0751 3 25 7.92487 25 14Z" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <input
            type="text"
            ref="searchTerm"
            value={search}
            onChange={this.handleSearchInputChange}
            placeholder={
              searchOnly
                ? t('search_tabs.vehicle_details_cvl')
                : t('search_tabs.vehicle_details')
            }
            disabled={showVRMLoader || showSearchLoader || (searchOnly && !type)}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && search !== '') {
                ReactGA.event({
                  category: i18n.language,
                  action: selectedFamily,
                  label: 'Search Submit',
                });
              }
            }}
          />
          {search && (
            <button type="button" className="clear-button" onClick={this.clearSearchInput} onTouchEnd={this.clearSearchInput} aria-label="Clear" disabled={showVRMLoader || showSearchLoader || (searchOnly && !type)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="rgba(32, 32, 32, 1)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
          <button type="submit" aria-label="Submit" disabled={showVRMLoader || showSearchLoader || (searchOnly && !type)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90 12 12)" />
            </svg>
          </button>
        </form>
      </div>
    );

    const dualSearchContent = (
      <div className="search-content">
        <div className="dual-search-wrapper">
          {t('config.show_vrm') && registrationContent}
          {searchContent}
        </div>
        {errorBlock}
      </div>
    );

    const handleBackToSearch = () => {
      this.setState({
        updated: false,
        search: '',
        vrm: '',
        type: '',
        error: false,
        errorSource: null,
        PVLData: null,
        CVLData: null,
        showSearchLoader: false,
      });
      if (this.props.onSearchComplete) {
        this.props.onSearchComplete(false);
      }
    };

    const refinePVLSearchForm = (
      <RefinePVLSearchForm
        key={selectedFamily}
        data={PVLData}
        selectedFamily={selectedFamily}
        equipment={this.equipment}
        onBackToSearch={handleBackToSearch}
      />
    );
    const refineCVLSearchForm = (
      <RefineCVLSearchForm
        key={selectedFamily}
        data={CVLData}
        selectedFamily={selectedFamily}
        equipment={this.equipment}
        onBackToSearch={handleBackToSearch}
      />
    );

    const forms = searchOnly && type ? refineCVLSearchForm : refinePVLSearchForm;

    const modelSelector = (
      <div className="model-select">
        <p className="select-vehicle-model">{t('search_tabs.select_model')}</p>
        <p className="vrm-manufacturer">{`${t(
          'vehicle_spec.manufacturer',
        )} ${vrmSearchManufacturer}`}</p>
        <SelectInput
          key={selectedFamily}
          handleChange={this.equipment}
          options={vrmSearchResults}
          value="model"
          disabled={showVRMLoader || showSearchLoader}
        />
      </div>
    );

    const commercialSearchContent = (
      <div className="search-content">
        <div className="dual-search-wrapper">
          <div className="type-select">
            <SelectInput
              key={selectedFamily}
              handleChange={this.handleTypeChange}
              options={typeOptions}
              value="type"
              title="type"
              selected={type}
              disabled={showSearchLoader}
              labelAsPlaceholder={true}
            />
          </div>
          {searchContent}
        </div>
        {errorBlock}
      </div>
    );

    return groups ? (
      <div>
        {!updated && (
          <section className="search-tabs" ref={(node) => (this.ref = node)}>
            {searchOnly && typeOptions ? commercialSearchContent : ''}
            {!searchOnly ? dualSearchContent : ''}
            {showVRMLoader && loader}
            {showSearchLoader && loader}
            {!searchOnly && vrmSearchResults && modelSelector}
          </section>
        )}
        {updated ? forms : ''}
      </div>
    ) : (
      loader
    );
  }
}

export default withRouter(translate('translations')(SearchTabs));
